import React from "react";
import PrivateRoute from "../utils/PrivateRoute";

// Dashboard
import FinancialAnalytics from "../dashboard/FinancialAnalytics";
import Expense from "../function/Expense";
import Income from "../function/Income";
import Bill from "../function/Bill";
import Goal from "../function/Goal";
import Budget from "../function/Budget";
// Apps

// Pages
import Pricing from "../pages/Pricing";
import Settings from "../pages/Settings";
import ContactUs from "../pages/ContactUs";
import FinancialReport from "../pages/reports/FinancialReport";
import ExpenseForecast from "../pages/ai/ExpenseForecast";
import SmartInsights from "../pages/ai/SmartInsights";
import BudgetOptimizer from "../pages/ai/BudgetOptimizer";
import DebtStrategy from "../pages/ai/DebtStrategy";
import AIChat from "../pages/ai/AIChat";
import AIFeatures from "../pages/ai/AIFeatures";


const protectedRoutes = [
  { path: "", element: <PrivateRoute><FinancialAnalytics /></PrivateRoute> },
  { path: "/dashboard/expense", element: <PrivateRoute><Expense /></PrivateRoute> },
  { path: "/dashboard/income", element: <PrivateRoute><Income /></PrivateRoute> },
  { path: "/dashboard/bill", element: <PrivateRoute><Bill /></PrivateRoute> },
  { path: "/dashboard/goal", element: <PrivateRoute><Goal /></PrivateRoute> },
  { path: "/dashboard/budget", element: <PrivateRoute><Budget /></PrivateRoute> },
  { path: "/dashboard/settings", element: <Settings /> },
  { path: "/dashboard/pricing", element: <Pricing /> },
  { path: "/dashboard/contact", element: <PrivateRoute><ContactUs /></PrivateRoute> },
  { path: "/dashboard/reports/financial", element: <PrivateRoute><FinancialReport /></PrivateRoute> },
  { path: "/dashboard/ai/forecast", element: <PrivateRoute><ExpenseForecast /></PrivateRoute> },
  { path: "/dashboard/ai/insights", element: <PrivateRoute><SmartInsights /></PrivateRoute> },
  { path: "/dashboard/ai/optimizer", element: <PrivateRoute><BudgetOptimizer /></PrivateRoute> },
  { path: "/dashboard/ai/debt-strategy", element: <PrivateRoute><DebtStrategy /></PrivateRoute> },
  { path: "/dashboard/ai/chat", element: <PrivateRoute><AIChat /></PrivateRoute> },
  { path: "/dashboard/ai", element: <PrivateRoute><AIFeatures /></PrivateRoute> }
]

export default protectedRoutes;